import { createReducer } from "@reduxjs/toolkit";
import type { UnpaidLessonVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { teacherRetrieveUnpaidLessons } from "./retrieve-unpaid-lessons";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<UnpaidLessonVM[]> = {
  fetching: "idle",
  data: [],
};

export const teacherRetrieveUnpaidLessonsReducer = createReducer(initialState, builder => {
  builder
    .addCase(teacherRetrieveUnpaidLessons.pending, state => {
      state.fetching = "pending";
    })
    .addCase(teacherRetrieveUnpaidLessons.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(teacherRetrieveUnpaidLessons.rejected, state => {
      state.fetching = "failed";
    });
});
